export const ICON_DEFAULT_COLOR = 'var(--color-icon-default)';

export const ICON_DEFAULT_SIZE = 24;
